import React, { useEffect, useState } from "react";
import "../index.scss";
import { QueryClient, QueryClientProvider } from "react-query";
import { Hydrate } from "react-query/hydration";
import { isDemoEnvironment, isLocalDev } from "rylak-common";
import DemoEnvironment from "../app/environments/demo/DemoEnvironment";
import DevEnvironment from "../app/environments/dev/DevEnvironment";
import ProdEnvironment from "../app/environments/prod/ProdEnvironment";

export default function IndexApp(props) {
    const { Component, pageProps: serverSideProps = {}, router } = props;
    const { urlHost } = serverSideProps; // appProps/serverSideProps comes from the getServerSideProps file

    useEffect(() => {
        // Grafana Frontend Observability
        import("../../faro"); // Avoids SSR issues
    }, []);

    const [queryClient] = useState(() => new QueryClient());

    const Environment = isDemoEnvironment() ? DemoEnvironment : isLocalDev() ? DevEnvironment : ProdEnvironment;
    // const Environment = DemoEnvironment;

    const [tempRender, setTempRender] = useState(false);
    useEffect(() => {
        //TODO Remove this
        // We do not want this but we have a problem with setting global CSS variables causing laggy behaviour on first render
        setTempRender(true);
    }, []);

    return (
        <QueryClientProvider client={queryClient}>
            <Hydrate state={serverSideProps?.dehydratedState || null}>
                {tempRender && <Environment Page={Component} serverSideProps={serverSideProps} router={router} queryClient={queryClient} />}
            </Hydrate>
        </QueryClientProvider>
    );
}
